import { api_host } from '../constants'

let isRefreshing = false; // Flag to indicate if a refresh is already in progress
let refreshQueue = []; // Queue to hold pending API calls

const refreshAccessToken = async () => {
    const response = await fetch(`${api_host}/auth/refresh-token`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const data = await response.json().catch(() => ({}));
    if (response.ok && data.success) {
        return true;
    }
    throw new Error('Failed to refresh Access Token');
};

const processQueue = (error) => {
    refreshQueue.forEach(([resolve, reject]) => {
        if (error) {
            reject(error);
        } else {
            resolve();
        }
    });
    refreshQueue = [];
};

const sendRequest = async (url, options) => {
    return await fetch(url, {
        ...options,
        credentials: 'include',
    });
};

const parseResponse = async (response) => {
    if (!response.ok) {
        const contentType = response.headers.get('content-type');
        let errorMessage = `API request failed: ${response.status} ${response.statusText}`;
        try {
            if (contentType && contentType.includes('application/json')) {
                const errorData = await response.json();
                errorMessage = errorData.error || errorData.message || errorMessage;
            } else {
                const errorText = await response.text();
                errorMessage = `${errorMessage}. ${errorText.substring(0, 200)}`;
            }
        } catch (e) {
            console.error('Could not parse error response:', e);
        }
        throw new Error(errorMessage);
    }

    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
        return await response.json();
    } else {
        const text = await response.text();
        throw new Error(`Expected JSON response but received ${contentType || 'unknown content type'}. Response: ${text.substring(0, 200)}`);
    }
};

export const apiFetch = async (url, options = {}) => {
    let response = await sendRequest(url, options);

    // Retry on 401 by attempting a refresh first
    if (response.status === 401) {
        if (!isRefreshing) {
            isRefreshing = true;
            try {
                await refreshAccessToken();
                processQueue(null);
            } catch (err) {
                processQueue(err);
                isRefreshing = false;
                window.location.href = '/login';
                throw err;
            }
            isRefreshing = false;
        } else {
            await new Promise((resolve, reject) => {
                refreshQueue.push([resolve, reject]);
            });
        }
        response = await sendRequest(url, options);
        if (response.status === 401) {
            window.location.href = '/login';
            throw new Error('Unauthorized');
        }
    }

    return await parseResponse(response);
};
